import React, { useState, useContext, useRef} from "react";

import {View, Text, BackHandler}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import {buscarPedido} from '../ws/ws_pedidos'

import contexto from '../util/contexto'

import * as data from '../util/data'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import {carregamento} from '../componentes/Carregamento'

import {ITEM_TIPO_PRODUTO, TELA_NOVA_PROPOSTA,LARGURA_AREA_CONTEUDO_PX, 
		TELA_NOVA_DENUNCIA, DNC_TIPO_SERVICO_PEDIDO,
		TELA_DETALHE_PEDIDO} from '../util/constantes'

import Botao from '../componentes/Botao'

import Scroll from '../componentes/Scroll'

import Bloco from '../componentes/Bloco'

import InfosLoja from '../componentes/InfosLoja'

import {buscar_loja} from '../ws/ws_usuarios'

import Imagem from '../componentes/Imagem'






export default function TelaDetalhePedido(){
   
	const {valorContexto, setValorContexto} = useContext(contexto);

	const [sincronizando, setSincronizando] = useState(true) 
	
	const navegacao = new useNavigation();
	
	const [pedido, setPedido] = useState(null)
	
	const [loja, setLoja] = useState(null) 



	const voltar = () => {
			
		navegacao.replace(util.processaVoltar())

		return true;	
	};
	

	useFocusEffect(React.useCallback(() => {

		util.print("TelaDetalhePedido");
		
		BackHandler.addEventListener('hardwareBackPress', voltar);

		buscarDados();

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	
	}, []));
	
	
	const buscarDados= async ()=>{

		setSincronizando(true);
		
		let aux = await buscarPedido(valorContexto.idPedido);
		
		if(util.temConteudo(aux)){
			
			setPedido(aux);

			setLoja( await buscar_loja(aux.fk_usuario))
		}
		else
			setPedido(null);

		setSincronizando(false)
	}
	

	return (
		<ViewDegradeVertical titulo="Detalhe de Pedido" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(<Scroll> 
					{formularioVisualizar()}

					<View>	
						<Bloco>  
							<View style={{marginTop:10}}/> 
							<View style={{alignItems:'center'}}>	
								<Botao 
									acao={()=>{
										
										setValorContexto(prevState =>({...prevState, tipoDenuncia: DNC_TIPO_SERVICO_PEDIDO}));
										
										setValorContexto(prevState =>({...prevState, idRelacaoDenuncia: valorContexto.idPedido}));				

										navegacao.replace(TELA_NOVA_DENUNCIA)
									}}
									somente_texto={true}
									texto="Denunciar Pedido"/>   
							</View>
							<View style={{marginTop:10}}/> 
						</Bloco> 
					</View>		
				</Scroll>)	
			} 
        </ViewDegradeVertical>
	)
		
		
	function fazerProposta(){

		console.log("fazerProposta id_pedido="+valorContexto.idPedido);
		
		util.setVoltar(TELA_DETALHE_PEDIDO);

		navegacao.navigate(TELA_NOVA_PROPOSTA)
	}


	function formularioVisualizar(){
		
		return(
			<View>
				<InfosLoja loja={loja} titulo="Solicitante"/>
				<Bloco>           			
					<View style={{marginTop:10}}/>  
							
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>Detalhes do Pedido</Text>	    
					</View>
					
					{pedido.imagem!=null && 
						<View style={{alignItems:'center'}}> 
							<View style={{marginTop:20}}/> 
							<Imagem imagem={pedido.imagem} tamanho={LARGURA_AREA_CONTEUDO_PX-200}/>
							<View style={{marginTop:10}}/> 
						</View> 
					}

					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_titulo}>Título:</Text>
							
					<View style={{marginTop:10}}/> 
							
					<Text style={estilos.rotulo_padrao}>{pedido.titulo}</Text>
				
					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_titulo}>Descrição:</Text>
							
					<View style={{marginTop:10}}/> 
							
					<Text style={estilos.rotulo_padrao}>{pedido.descricao}</Text>
			
					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_titulo}>Data Expiração:</Text>
							
					<View style={{marginTop:10}}/> 
							
					<Text style={estilos.rotulo_padrao}>{data.converteDataEuaParaBr(pedido.data_expiracao)}</Text>
			
					<View style={{marginTop:10}}/>

					<Text style={estilos.rotulo_titulo}>Situação:</Text>
							
					<View style={{marginTop:10}}/> 
							
					<Text style={estilos.rotulo_padrao}>{util.getDescricaoSituacaoPedido(pedido.situacao)}</Text>
						
					<Text style={estilos.rotulo_titulo}>Observação:</Text>
							
					<View style={{marginTop:10}}/> 
									
					<Text style={estilos.rotulo_padrao}>{pedido.obs}</Text>
							
					<View style={{marginTop:20}}/> 
						
					{valorContexto.idUsuarioAtual != pedido.fk_usuario && 
							<View style={{alignItems:'center'}}> 
								<Botao 
									acao={()=>fazerProposta()}
									somente_texto={true}
									texto="Fazer uma Proposta"/>  
							</View>
					}
						
					<View style={{marginTop:10}}/> 
				</Bloco>

				{pedido.itens.map((item, index) => itemLista(item, index))}
				
			</View>
		)
	}
	
	
	function itemLista(item, index){

		let infos = util.outrasInfosItem(item);

		return (
			<Bloco key={index}>  
				<View style={{marginTop:10}}/> 
				<View>           
					<Text style={estilos.rotulo_padrao}>{item.tipo ==ITEM_TIPO_PRODUTO?"Produto":"Serviço"}</Text>
				</View>
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				{util.temConteudo(item.descricao) && 
					<Text style={estilos.rotulo_padrao}>{util.substring(item.descricao, 60)}</Text>
				}
				
				{util.temConteudo(infos) && <Text style={estilos.rotulo_padrao}>{infos}</Text>}

				<Text style={estilos.rotulo_padrao}>QTDe {item.quantidade}</Text>
				{util.temConteudo(item.observacao) && <Text style={estilos.rotulo_padrao}>Obs: {item.observacao}</Text>}
				
				<View style={{marginTop:10}}/>
			</Bloco>)
	}
}